const PmiStructureEnum = Object.freeze({
    AIF: 'AIF',
    CAYMAN_LP: 'CAYMAN_LP',
    DELAWARE_LLC: 'DELAWARE_LLC',
    ELTIF: 'ELTIF',
    FUND: 'FUND',
    LIMITED_PARTNERSHIP: 'LIMITED_PARTNERSHIP',
    LTAF: 'LTAF',
    PRODUCT: 'PRODUCT',
    SICAV: 'SICAV',
    SICAV_RAIF: 'SICAV_RAIF',
    SINGAPORE_VCC: 'SINGAPORE_VCC',
    UNIT_TRUST: 'UNIT_TRUST'
});

export default PmiStructureEnum;

// Fund style structures (closed-ended)
export const PmiStructureClosedEndedEnum = Object.freeze({
    FUND: PmiStructureEnum.FUND,
    LIMITED_PARTNERSHIP: PmiStructureEnum.LIMITED_PARTNERSHIP,
    UNIT_TRUST: PmiStructureEnum.UNIT_TRUST
});

// Product style structures (open-ended)
export const PmiStructureOpenEndedEnum = Object.freeze({
    PRODUCT: PmiStructureEnum.PRODUCT,
    SICAV: PmiStructureEnum.SICAV,
    AIF: PmiStructureEnum.AIF,
    LTAF: PmiStructureEnum.LTAF,
    ELTIF: PmiStructureEnum.ELTIF,
    SICAV_RAIF: PmiStructureEnum.SICAV_RAIF,
    DELAWARE_LLC: PmiStructureEnum.DELAWARE_LLC,
    CAYMAN_LP: PmiStructureEnum.CAYMAN_LP,
    SINGAPORE_VCC: PmiStructureEnum.SINGAPORE_VCC
});
